
import { dataStructureActionTypes } from '@constants/actionTypes/ssapActionTypes';

export const INITIAL_STATE = {
    taxHouseholdStructure: null
};

export default (state = INITIAL_STATE, action = {}) => {
    switch(action.type) {
        case dataStructureActionTypes.SET_DATA_STRUCTURE:
            return {
                ...state,
                ...action.update
            };

        case dataStructureActionTypes.INITIALIZE_SSAP:
            return action.payload.dataStructure
                ? { ...state, ...action.payload.dataStructure }
                : state;

        case dataStructureActionTypes.CLEAR_SSAP_STATE:
            return INITIAL_STATE;
            
        default:
            return state;
    }
};